import { useEffect } from 'react';
import { useParticipantProperty } from '@daily-co/daily-react';

function ParticipantProcessor({ id, onTeacherFound, onRegularParticipant }) {
  const username = useParticipantProperty(id, 'user_name');
  const isTeacher = useParticipantProperty(id, 'owner');

  useEffect(() => {
    if (isTeacher) {
      onTeacherFound?.(id);
    } else {
      onRegularParticipant?.(id);
    }
  }, [id, username, isTeacher, onTeacherFound, onRegularParticipant]);

  return null;
}

export default ParticipantProcessor;
